// @flow
import * as React from 'react';
import classnames from 'classnames';
import './stylesheets/OrchEmptyState.scss';

type Props = {
  title: string,
  subtitle: string,
  hidden?: boolean,
  children: React.Node
};

const OrchEmptyState = (props: Props) => {
  const { title, subtitle, children, hidden } = props;
  return (
    <div className="OrchEmptyState">
      <div className={classnames('OrchEmptyState__MainContainer', { hidden })}>
        <div className="OrchEmptyState__Title">{title}</div>
        <div className="OrchEmptyState__Subtitle">{subtitle}</div>
        {children}
      </div>
    </div>
  );
};

OrchEmptyState.defaultProps = {
  hidden: false
};

export default OrchEmptyState;



// WEBPACK FOOTER //
// ./src/components/OrchEmptyState.jsx